import React from 'react';
// components
import Refresh from '@material-ui/icons/Refresh';
import CommonButton, { CommonButtonProps } from './CommonButton';

type Props = Omit<CommonButtonProps, 'icon' | 'label' | 'type'> & {
  label?: CommonButtonProps['label'];
  type?: CommonButtonProps['type'];
};

export const RefreshButton = (props: Props): JSX.Element => {
  const label = props.label !== undefined ? props.label : 'Refresh';
  const type = props.type !== undefined ? props.type : 'icon';
  return <CommonButton
    { ...props }
    type={ type }
    label={ label }
    icon={ type === 'text' ? undefined : <Refresh /> }
  />;
};

export default RefreshButton;
